import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form, Button, 
    // Icon 
} from "antd";
// import { OrderedMap } from "immutable";
import {
    fieldGenerator,
    getErrorOnField,
    // getValidateStatus,
    submitForm
} from "utilities/form";
import "styles/form.css";
import { BUSINESS_CASHBACK_DETAILS } from "constants/form-fields";

const FormItem = Form.Item;
class BusinessCashbackDetailsForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    handleFormSubmit = submitForm.bind(this.props.form, () => null);

    state = {
        product_list: [],
        showForm: false
    };

    componentDidMount() {
        if(!this.state.form && ((this.props.values && this.props.values.get("id")) || (this.props.parentProgramData && this.props.parentProgramData.get("id"))) ) {
            this.setState({
                showForm: true
            });
        }
    }

    saveCashbackDetails = () => {
        const { form } = this.props;
        form.validateFields((err, values) => {
            this.props.values && this.props.values.get("id") ? this.props.updateCashbackDetails({...values, business_program: this.props.businessProgramId}) : this.props.saveCashbackDetails({...values, business_program: this.props.businessProgramId});
        });
    }

    render() {
        return (
            <div className={"p-10"}>
                {this.state.showForm || (this.props.values && this.props.values.get("id") || this.props.parentProgramData)  ? <Form
                    className={cx("form", "br-3")}
                >
                    <div className={"form-row"}>
                        {BUSINESS_CASHBACK_DETAILS.map((field, fieldName) =>
                            this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )()
                        ).toList()}
                    </div>
                </Form> : null}
                {!this.props.values || !this.props.values.get("id") || !this.props.parentProgramData ? <FormItem className={cx("form-btn m-0")}>
                    <Button
                        type="dashed"
                        icon={"plus"}
                        // disabled={this.props.formDisabled}
                        onClick={() => {
                            this.setState({
                                showForm: !this.state.showForm
                            });
                        }}>
                        {this.state.showForm ? "Remove" : "Add Cashback Details"}
                    </Button>
                </FormItem> : null}
                <div className="d-flex justify-content-flex-end">
                    <FormItem className={cx("mr-5")}>
                        <Button key="save" type="primary" icon={"plus"} onClick={this.saveCashbackDetails}>{this.props.values && this.props.values.get("id") ? "Update" : "Save"}</Button>
                    </FormItem>
                </div>
                
            </div>
        );
    }
}

BusinessCashbackDetailsForm.propTypes = {
    form: PropTypes.object,
    saveCashbackDetails: PropTypes.func,
    businessProgramId: PropTypes.number,
    values: PropTypes.object,
    updateCashbackDetails: PropTypes.func,
    parentProgramData: PropTypes.object
};

export default Form.create({
    mapPropsToFields: ({ values, parentProgramData }) => {
        let newValues = values && values.get("id") ? values : parentProgramData;
        return newValues &&
        newValues
            .toSeq()
            .toMap()
            .map((value) => {
                return Form.createFormField({
                    value
                });
            })
            .toJS();
    }
})(BusinessCashbackDetailsForm);